import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import Dialog, { type DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import DialogActions from '@liquidweb-dev/undercurrent/DialogActions';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import useNetworkDnsDomainContactList from 'modules/queries/network/dns/domain/contact/useList';
import useSendEPPCode from 'modules/queries/network/dns/domain/transfer/useSendEPPCode';

export interface DialogTransferOutDomainProps
	extends Omit<DialogProps, 'onClose'> {
	domain: string;
	uniqId: string;
	onClose: () => void;
}

const DialogTransferOutDomain = ({
	domain,
	uniqId,
	onClose,
	open,
	...rest
}: DialogTransferOutDomainProps) => {
	const { data: contactListData, isLoading: isLoadingEmail } =
		useNetworkDnsDomainContactList(
			{ domain },
			{
				enabled: open,
			},
		);

	const { mutate: sendEPPCode, isLoading: isSending } = useSendEPPCode();

	const email = contactListData?.contacts.registrant.RegistrantEmailAddress;

	const handleConfirm = () => {
		sendEPPCode(
			{ uniq_id: uniqId },
			{
				onSuccess: () => {
					onClose();
				},
			},
		);
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth {...rest}>
			<DialogTitle onClose={onClose}>Transfer this domain</DialogTitle>
			<DialogContent>
				<Typography
					variant="body-sm"
					sx={{ color: ({ vars }) => vars.palette.uc.text.weak }}
				>
					This will unlock the domain so that it can be transferred. An EPP code
					will be sent to{' '}
					{!isLoadingEmail && email ? (
						<Box component="span" sx={{ fontWeight: 500 }}>
							{email}
						</Box>
					) : (
						'your registrant email address'
					)}
					. Once you have the EPP code, you must notify the receiving registrar
					to continue the transfer process.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button
					variant="secondary"
					size="large"
					onClick={onClose}
					sx={{ flex: 1 }}
				>
					Cancel
				</Button>
				<Button
					color="highlight"
					onClick={handleConfirm}
					loading={isSending}
					size="large"
					sx={{ flex: 1 }}
				>
					Confirm transfer
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DialogTransferOutDomain;
